/**
 * @file Curved reset arrow icon for "reset to checkpoint" affordances.
 * @module @labcraft/ui/icons/reset-arrow
 *
 * Inline SVG inheriting `currentColor`. Consumers control size via
 * `width`/`height` props or CSS, color via `color` on a parent.
 */

import type { JSX, SVGProps } from 'react'

type IconProps = SVGProps<SVGSVGElement>

/**
 * Reset / circular-arrow icon.
 *
 * @param props - Pass-through props for the underlying `<svg>`.
 * @returns The rendered icon.
 */
export function ResetArrowIcon(props: IconProps): JSX.Element {
  return (
    <svg
      viewBox="0 0 12 12"
      width={12}
      height={12}
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      {...props}>
      <path d="M2.5 6 A3.5 3.5 0 1 1 6 9.5" />
      <polyline points="2.5,3.5 2.5,6 5,6" />
    </svg>
  )
}
